// @flow
// $FlowFixMe
import React, { useMemo } from "react";
import TabGroup from "../../_molecules/TabGroup";
import TabsContainer from "./styled-components";
import type { TabItem } from "../../_molecules/TabGroup/types";

type Props = {
  tabs: TabItem[],
  withVideo: boolean,
  fixedOffset: number,
  isSticky: boolean
};

const ProgramPageTabs = (props: Props) => {
  const { fixedOffset, tabs, withVideo, isSticky } = props;

  return useMemo(
    () => (
      <TabsContainer
        isSticky={isSticky}
        fixedOffset={fixedOffset}
        withVideo={withVideo}
      >
        <TabGroup tabs={tabs} hasBottomShadow isBigTab />
      </TabsContainer>
    ),
    [fixedOffset, withVideo, tabs]
  );
};

ProgramPageTabs.defaultProps = {
  tabs: [],
  hasBorderBottom: false,
  isBigTab: false,
  withVideo: false,
  fixedOffset: 48,
  isSticky: true
};

export default ProgramPageTabs;
